export default {
  placeholderApiUrl: 'https://nespresso-mage-prod.projectanddemoserver.com/rest'
}
